// Import model
import { DiscountRate } from '../models/DiscountRate';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DiscountRate - handles JSON serialization and deserialization with type validation
 */
export class DiscountRateSerializer {
  /**
   * Deserializes a JSON string into a DiscountRate instance
   */
  static deserialize(json: string): DiscountRate {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DiscountRate instance
   */
  static fromObject(obj: any): DiscountRate {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DiscountRate');
    }


    const instance: DiscountRate = {
      category: obj['category'] as string | undefined,
      rate: obj['rate'] as number | undefined,
      amount: obj['amount'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DiscountRate instances
   */
  static deserializeArray(json: string): DiscountRate[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DiscountRate instance to a JSON string
   */
  static serialize(instance: DiscountRate): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DiscountRate instance to a plain object
   */
  static toObject(instance: DiscountRate): any {
    return {
      'category': instance.category,
      'rate': instance.rate,
      'amount': instance.amount,
    };
  }

  /**
   * Serializes an array of DiscountRate instances to a JSON string
   */
  static serializeArray(instances: DiscountRate[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
